"use strict";

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.ssrWindow = {}));
})(void 0, function (exports) {
  'use strict';
  /* eslint-disable no-param-reassign */

  function isObject(obj) {
    return obj !== null && _typeof(obj) === 'object' && 'constructor' in obj && obj.constructor === Object;
  }

  function extend(target, src) {
    if (target === void 0) {
      target = {};
    }

    if (src === void 0) {
      src = {};
    }

    Object.keys(src).forEach(function (key) {
      if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        extend(target[key], src[key]);
      }
    });
  }

  var ssrDocument = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ''
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS: function createElementNS() {
      return {};
    },
    importNode: function importNode() {
      return null;
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    }
  };

  function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
  }

  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ''
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    },
    history: {
      replaceState: function replaceState() {},
      pushState: function pushState() {},
      go: function go() {},
      back: function back() {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
      return {};
    },
    requestAnimationFrame: function requestAnimationFrame(callback) {
      if (typeof setTimeout === 'undefined') {
        callback();
        return null;
      }

      return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(id) {
      if (typeof setTimeout === 'undefined') {
        return;
      }

      clearTimeout(id);
    }
  };

  function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
  }

  exports.extend = extend;
  exports.getDocument = getDocument;
  exports.getWindow = getWindow;
  exports.ssrDocument = ssrDocument;
  exports.ssrWindow = ssrWindow;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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